import { UUID } from "../types";
import { UserInitAccess } from "./use-user-init-access.types";

export const getUserInitAccess = async (initId: UUID): Promise<Omit<UserInitAccess, "hasLoadedAccess">> => {
  const response = await fetch(`${window.gxApiConnection}/api/v3/initiatives/${initId}/access`, {
    method: "GET",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Failed to retrieve user init access");
  }
  const { data } = await response.json();
  return data;
};